// Bits visuais compartilhados do Dashboard: Card, Avatar, cores de canal/tag.
import React from "react";
import {
  CH,
  TAGS,
  attendantColor,
  initials,
} from "../../CrmKanban/kanban/tokens";

export const Card = ({ V, children, style }) => (
  <div
    style={{
      background: V.cardBg,
      border: V.cardBorder,
      borderRadius: V.cardRadius,
      boxShadow: V.cardShadow,
      padding: "15px 17px",
      display: "flex",
      flexDirection: "column",
      gap: 9,
      minWidth: 0,
      ...style,
    }}
  >
    {children}
  </div>
);

export const CardTitle = ({ V, children, right }) => (
  <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
    <span
      style={{
        fontSize: 13.5,
        fontWeight: V.cardTitleWeight,
        color: V.textStrong,
      }}
    >
      {children}
    </span>
    {right != null && <span style={{ flex: 1 }} />}
    {right}
  </div>
);

export const Avatar = ({ name, V, size = 22 }) => (
  <span
    style={{
      width: size,
      height: size,
      borderRadius: V.avatarRadius,
      background: attendantColor(name),
      color: "#fff",
      fontSize: 9,
      fontWeight: 800,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: "none",
    }}
  >
    {initials(name)}
  </span>
);

// Canal -> [label, cor]. Fallback determinístico p/ canais fora da paleta.
export const channelMeta = (key) => {
  const k = String(key || "").toLowerCase();
  if (CH[k]) return CH[k];
  const label = k ? k.charAt(0).toUpperCase() + k.slice(1) : "Outro";
  return [label, attendantColor(k)];
};

// Tag -> [text, bg]. Fallback p/ tags não catalogadas.
export const tagColors = (tag) => {
  if (TAGS[tag]) return TAGS[tag];
  const c = attendantColor(tag);
  return [c, "#EEF1F4"];
};
